import experiment from 'experiment';

export const isMeshLayoutEnabled = () => experiment.isOpen('se_meshLayout');
